module.exports = __webpack_public_path__ + "img/marker_menjar.5ec90ea1.svg";